module.exports = __webpack_public_path__ + "img/viessmann-heating-system-sm.21a5462e.svg";